import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RequestSummaryViewModel } from '../Model/requestSummaryViewModel';
import { RequestService } from '../services/requests.services';
import * as _moment from 'moment';
import { default as _rollupMoment } from 'moment';
import { FormControl } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { Subscription } from 'rxjs';
import { UpdateRequestViewModel } from '../Model/UpdateRequestViewModel';

const moment = _rollupMoment || _moment;

@Component({
  selector: 'app-request',
  templateUrl: './request.component.html',
  styleUrls: ['./request.component.css']
})
export class RequestComponent implements OnInit, OnDestroy {
  requestId: number | undefined;
  requestSummary!: any;
  requestTitle!: string;
  tempRequestTitle!: string;
  isChanged = false;
  canClose: boolean;
  canEnlargeDeadline: boolean;
  newDate: any;
  minDate = new Date();
  isNestedModalOpen = false;
  isRequestLoading = false;
  requestModel: UpdateRequestViewModel;
  requestSummarysubscription?: Subscription;
  requestSubscription?: Subscription;
  updateSummarySubscription?: Subscription;
  closedRequestSubscription?: Subscription;
  editDueDateSubscription?: Subscription;
  isError = false;
  errorMessage = '';
  readonly ErrMessage = "Error stack: ";
  @Input() id = 0;

  constructor(private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly requestService: RequestService) {
    this.requestId = this.id;
    this.requestModel = { requestId : this.id, dueDate : null };
    this.canClose = false;
    this.canEnlargeDeadline = false;
  }
  ngOnDestroy(): void {
    this.requestSummarysubscription?.unsubscribe();
    this.requestSubscription?.unsubscribe();
    this.updateSummarySubscription?.unsubscribe();
    this.closedRequestSubscription?.unsubscribe();
    this.editDueDateSubscription?.unsubscribe();
  }

  ngOnInit() {
    this.requestId = this.id;
    this.requestModel = { requestId : this.id, dueDate : null };
    this.canClose = false;
    this.canEnlargeDeadline = false;
    console.log("Request ID: " + this.requestId);
    this.getRequestSummary(Number(this.requestId));
  }

  getRequestSummary(id: number) {
    this.isRequestLoading = true;
    this.requestSummarysubscription = this.requestService.getrequestsummary(id).subscribe({
      next: (response: any) => {
        this.requestSummary = response;        
        this.requestTitle = response.title;
        this.tempRequestTitle = response.title;
        this.newDate = new FormControl(moment(response.dueDate).toDate());       
        this.canModifyRequestSummary(id); 
      },
      error: (error: any) => {        
        this.isError = true;        
        this.errorMessage = error.error;

        switch (error.status) {
            case 400:
              this.errorMessage = "The request ID is not valid!";
              error.statusText = 'BadRequest'
              break;            
            case 404:
              this.errorMessage = `The request with id ${id} is not found!`;
              error.statusText = 'NotFound'
              break;
            default:
              this.errorMessage = "The request not found!";
              error.statusText = 'BadRequest'
              break;
          }       
        console.log(`Error in loading Request details for: ${id} !Error Message:  ${this.errorMessage}`);
        this.isRequestLoading = false;
      },
      complete: () => { this.isRequestLoading = false; }
    });
  }

  canModifyRequestSummary(id: number) {
    this.requestSubscription = this.requestService.canModifyRequestSummary(id).subscribe({
      next: (response: any) => {
        this.canClose = response.canClose;
        this.canEnlargeDeadline = response.canEnlargeDeadline;
      },
      error: (error: any) => {
        console.log("Error in getting Request Summary with links: " + error)
      },
      complete: () => { this.isRequestLoading = false; }
    });
  }

  openConfirmationDialog(action: string) {
    if (action === 'save') {
      if (confirm("Do you want to save the changes?")) {
        console.log("Updating Request Summary");
        console.log("Change in Request Title: " + this.requestSummary.title);
        this.requestSummary.title = this.requestTitle;
        this.updateRequestSummary(this.requestSummary);
      }
    }

    if (action === 'close') {
      if (confirm("Are you sure to close this request? It will no longer be possible to provide any feedback on the Task(s) to Review.")) {
        console.log(`Closing Request: ${this.requestId}  ${this.requestTitle}`);
        this.closeRequest(Number(this.requestId));
      }
    }
  }

  updateRequestSummary(requestSummary: RequestSummaryViewModel) {
    this.isRequestLoading = true;
    this.updateSummarySubscription = this.requestService.updateRequestSummary(requestSummary).subscribe({
      next: (response: any) => {
        this.tempRequestTitle = requestSummary.title;
        this.isChanged = false;
      },
      error: (error: any) => {
        console.log("Error in updating Request Summary: " + error.message)
        console.log(this.ErrMessage + error.stack)
      },
      complete: () => {
        this.isRequestLoading = false;
      }
    });
  }

  closeRequest(requestId: number) {
    this.isRequestLoading = true;
    this.closedRequestSubscription = this.requestService.closeRequest(requestId).subscribe({
      next: (response: any) => {
        this.canClose = false;
        this.router.navigate(['/requests']);
      },
      error: (error: any) => {
        console.log(`Error in closing Request: [${this.requestId}] ${this.requestTitle}`);
        console.log(this.ErrMessage + error.stack)
      },
      complete: () => { this.isRequestLoading = false; }
    });
  }

  datePickerEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    if (this.canEnlargeDeadline && type === 'change') {
      const oldDueDate = moment(this.requestSummary.dueDate);
      const newDueDate = moment(event.value?.toString());

      if (oldDueDate === newDueDate) {
      } else {               
        this.requestModel.dueDate = event.value;
        this.editDueDate(this.requestModel);

      }      
    }
  }

  editDueDate(requestModel: UpdateRequestViewModel) {
    this.isRequestLoading = true;
    this.editDueDateSubscription = this.requestService.editDueDate(requestModel).subscribe({
      next: (response: any) => {
        this.router.navigate(['/requests']);  
      },
      error: (error: any) => {
        console.log(`Error in editing of DueDate Request: [${this.requestId}] ${this.requestTitle}`);
        console.log(this.ErrMessage + error.stack)
      },
      complete: () => { this.isRequestLoading = false; }
    });
  }

  valueChange(newValue: any) {
    if (this.requestTitle === this.tempRequestTitle) {
      this.isChanged = false;
    } else {
      this.isChanged = true;
    }
  }

  openModal() {
    this.isNestedModalOpen = true;
  }

  closeModal() {
    this.isNestedModalOpen = false;
  }
}
